import { client } from 'config/graphql/client';
import { DEMO_MODE_INFO_MESSAGE } from 'config/graphql/errors';
import { IS_USER_ADMIN } from 'config/graphql/queries';
import { CloudError } from 'repository/CloudError';
import { NOT_IMPLEMENTED } from 'repository/messages';
import { type CloudResult, type RepositoryCacheType } from 'repository/repository';
import type Repository from 'repository/repository';
import { type AuthenticatedUserInterface } from 'typedefs/authTypes';
import { type UserAdminOrSuperAdmin } from 'typedefs/store/tmxTypes';
import { isStandalone } from 'utils/environment';

export interface UserManagementRepository extends Repository<AuthenticatedUserInterface> {
  getUserPermissions(tournamentId: string, cache?: RepositoryCacheType): Promise<CloudResult<UserAdminOrSuperAdmin>>;
}

export class UserManagementRepositoryImpl implements UserManagementRepository {
  get(id: string, cache?: RepositoryCacheType): Promise<CloudResult<AuthenticatedUserInterface>> {
    console.log(id, cache);
    return Promise.resolve({ error: NOT_IMPLEMENTED });
  }

  save(item: AuthenticatedUserInterface) {
    console.log(item);
    return Promise.resolve({ error: NOT_IMPLEMENTED });
  }

  async getUserPermissions(
    tournamentId: string,
    cache?: RepositoryCacheType,
  ): Promise<CloudResult<UserAdminOrSuperAdmin>> {
    if (isStandalone()) {
      return Promise.resolve({ error: new CloudError('demo-mode-query', DEMO_MODE_INFO_MESSAGE) });
    }

    const graphqlResult = await client.query<UserAdminOrSuperAdmin>({
      query: IS_USER_ADMIN,
      fetchPolicy: cache,
      variables: {
        tournamentId: tournamentId,
      },
    });

    if (graphqlResult.error) {
      return Promise.resolve({ error: new CloudError(graphqlResult.error.name, graphqlResult.error.message) });
    }
    return Promise.resolve({ data: graphqlResult.data });
  }
}
